module.exports = __webpack_public_path__ + "static/img/footer-topbg.51588ef.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/footer-topbg.png
// module id = pqdi
// module chunks = 1